import React from "react";

export const Logo = function () {
  return <img className={'teamToday__logo'} src="/assets/images/logos/team-today-header-logo.svg" alt="Team Today"/>
}
